import styled from "styled-components/native";
import ReviewPageCard from "./ReviewPageCard";
import { SpaceType } from "@components/atoms/Spacer/types";
import PriceCardContainer from "./PriceCardContainer";
import PDPModal from "./PdpModal";
import { useState } from "react";
import { useProductPrefix } from "../../../hooks/useProductPrefix";

const StoneCard = ({
  stoneItemDetail,
  priceMode,
  toggleGalleryItem,
  matchingPair,
  fromRequest,
  selectedType,
  type,
  isFirstBreadcrumbStoneDetailPage,
  startFromStone,
}: any) => {
  const [showModal, setShowModal] = useState(false);
  const productPrefix = useProductPrefix(stoneItemDetail?.type);
  const route = {
    params: {
      productID: stoneItemDetail.id,
      productType: stoneItemDetail?.type,
      priceMode: priceMode,
      productPrefix: productPrefix,
      stoneItemDetail: stoneItemDetail,
    },
  };
  return (
    <Overlay>
      <ReviewPageCard
        key={stoneItemDetail?.id}
        itemDetail={stoneItemDetail}
        type={type}
        setShowModal={setShowModal}
        toggleGalleryItem={toggleGalleryItem}
        matchingPair={matchingPair}
        fromRequest={fromRequest}
        selectedType={selectedType}
        isFirstBreadcrumbStoneDetailPage={isFirstBreadcrumbStoneDetailPage}
        startFromStone={startFromStone}
      />
      <PriceCardContainer itemDetail={stoneItemDetail} type={type} />
      <PDPModal
        route={route}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </Overlay>
  );
};

export default StoneCard;

const Overlay = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
`;
